export default {
  image: 'P-3614-3075.png',
  pdf: '211103_WA-MIWO_022_P-3614-3075_ar.pdf',
  productData: {
    serialNumber: 'WA-MIWO-022',
    technicalValues: {
      soundReductionIndex: {
        output: '48,2',
        value: 48.2
      },
      heatTransferCoefficient: {
        output: '0,18',
        value: 0.18
      },
      fireBehavior: {
        output: 'schwerentflammbar (B1)',
        value: 'B1'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Mineralwolle l Aufbau 22',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '50 mm Sto-Speedlamelle Typ ll',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'msp-50'
        },
        {
          output: '16 mm Spanplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opc-16'
        },
        {
          output: '70/165',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-165'
        },
        {
          output: '160 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-160'
        },
        {
          output: '16 mm Spanplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ii-16'
        },
        {
          output: '9,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'im-9'
        },
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '267,5',
        value: 267.5
      }
    }
  }
}
